import { render, staticRenderFns } from "./screen-card.vue?vue&type=template&id=0cc9285a"
import script from "./screen-card.vue?vue&type=script&lang=ts"
export * from "./screen-card.vue?vue&type=script&lang=ts"
import style0 from "./screen-card.vue?vue&type=style&index=0&id=0cc9285a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports